export default {
    editVisitKey(state, key) {
        state.visit.key = key
    },
    editVisit(state, data) {
        state.visit = data
    },
    cleanVisit(state) {
        state.visit.key = undefined
        state.visit.objectTitle = undefined
        state.visit.objectLatitude = undefined
        state.visit.objectLongitude = undefined
        state.visit.userLatitude = undefined
        state.visit.userLongitude = undefined
        state.visit.userIcon = undefined

    }
}
